import { useEffect, useMemo } from 'react'

import { useShallow } from 'zustand/react/shallow'

import useComponentPerfRenderingStore from './useComponentPerfRenderingStore'

export const HOME_SCREEN_LOADED_PERF_TRACE = 'home_screen_loaded'
export const HOME_SCREEN_LOADED_PERF_TRACE_V3 = 'home_screen_loaded_v3'

type UseComponentInitialMountProps = {
  componentName: string
  hasLoaded: boolean
  isEnabled?: boolean
}

export const useComponentInitialMount = ({
  componentName,
  hasLoaded,
  isEnabled = true,
}: UseComponentInitialMountProps) => {
  const [addTrackingComponent, removeComponentTracking] =
    useComponentPerfRenderingStore(
      useShallow((state) => [
        state.addTrackingComponent,
        state.removeComponentTracking,
      ])
    )

  // todo: take care of the env file, only available to zet-app
  // const isPerfMonitoringEnabled = env?.FIREBASE_PERF_ENABLE

  useMemo(() => {
    isEnabled && addTrackingComponent(componentName, false)
  }, [addTrackingComponent, componentName, isEnabled])

  useEffect(() => {
    // if (isPerfMonitoringEnabled && hasLoaded) {
    if (isEnabled && hasLoaded) {
      addTrackingComponent(componentName, hasLoaded)
    }

    return () => {
      removeComponentTracking(componentName)
    }
  }, [
    hasLoaded,
    componentName,
    addTrackingComponent,
    removeComponentTracking,
    isEnabled,
  ])
}
